import * as React from 'react'

import { NextPage } from '@grandvisionhq/next'
import {
  ErrorCase,
  InitialProps,
  Page,
  Props,
} from '@grandvisionhq/www-next/pages/product-detail/contact-lens'
import { PromoteInstallmentsGraphContainer } from '@grandvisionhq/www-next/slot-components/PromoteInstallmentsGraphContainer'

import { composePDP } from '../../../components/hocs/compose-pdp'
import { settings as cartSettings } from '../../../components/hocs/with-cart'
import {
  clSpecifications,
  getDeliveryIndicatorConfig,
  graphPromoteInstallmentsConfiguration,
} from '../../../configuration'

const slots: Props['slots'] = {
  AfterPrice: () => (
    <PromoteInstallmentsGraphContainer opcoConfiguration={graphPromoteInstallmentsConfiguration} />
  ),
}

const ProductDetailPage: NextPage<Props, InitialProps | ErrorCase> = (props) => {
  const deliveryIndicatorConfig = getDeliveryIndicatorConfig()

  return (
    <Page
      {...props}
      slots={slots}
      deliveryIndicatorConfig={deliveryIndicatorConfig}
      specificationConfiguration={clSpecifications}
      maxOrderableQuantity={cartSettings.maximumQuantity}
    />
  )
}

ProductDetailPage.getInitialProps = Page.getInitialProps

export default composePDP<Props>(ProductDetailPage)
